import type { User } from './auth';
export function isPublicPortalPath(path: string) {
    // /go/:code is an email's short link: it must work before sign-in.
    return path.startsWith('/go/') || ['/auth', '/signup', '/forgot-password', '/reset-password', '/privacy', '/terms', '/auth-callback', '/help', '/access-help'].includes(path);
}
export function portalRedirect(signedIn: boolean, path: string) {
    if (!signedIn && !isPublicPortalPath(path))
        return '/auth';
    if (signedIn && ['/auth', '/signup', '/onboarding', '/'].includes(path))
        return '/coach';
    return null;
}
/** Display identity only. Entitlement is checked independently by the Coach API. */
export function portalUser(identity: {
    id: string;
    email?: string;
    user_metadata?: Record<string, unknown>;
}): User {
    return { id: identity.id, email: identity.email || '', full_name: typeof identity.user_metadata?.full_name === 'string' ? identity.user_metadata.full_name : '', is_pro: false, is_cap_member: false, onboarding_complete: false };
}
